import { graphql, Script, useStaticQuery } from "gatsby";
import React, { Fragment, useEffect, useState } from "react";
import SnapChatpixel from "../utils/snapchatpixel";
import Footer from "./footer";
import PromoBar from "./promobar";
import Popup from "./Popup";
import { Toaster } from "react-hot-toast";
import ExitIntent from "../utils/ExitIntent";
import ExitPopup from "./ExitPopup";
import AccessibilityWidget from "./Accessibility";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityPromobar {
        nodes {
          id
          title
          linkType
          slug {
            current
          }
          link
        }
      }
      sanityFooter {
        loyaltyButtonTitle
        signupPopup {
          state
          heading
          subheading
          image {
            asset {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: BLURRED
                formats: WEBP
              )
            }
          }
        }
        enableExitIntent
        exitPopup {
          state
          heading
          description
          image {
            asset {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: BLURRED
                formats: WEBP
              )
            }
          }
          button {
            buttonText
            buttonType
            buttonColor
            linkType
            pdf {
              asset {
                url
              }
            }
            slug {
              current
            }
            url
          }
          button2 {
            buttonText
            buttonType
            buttonColor
            linkType
            pdf {
              asset {
                url
              }
            }
            slug {
              current
            }
            url
          }
        }
      }
    }
  `);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hidePopup, setHidePopup] = useState(false);
  const [isOrderPage, setIsOrderPage] = useState(false);
  const [exitPopup, setExitPopup] = useState(false);

  useEffect(() => {
    setIsOrderPage(
      typeof window !== "undefined" && window.location.pathname === "/order"
    );
    if (document.cookie.indexOf("exit_modal_seen=true") < 0) {
      const removeExitIntent = ExitIntent({
        threshold: 30,
        eventThrottle: 100,
        onExitIntent: () => {
          setExitPopup(true);
          let expiryDate = new Date(Date.now() + 1 * (1000 * 60 * 60 * 1));
          document.cookie =
            "exit_modal_seen" + "=true; expires=" + expiryDate.toUTCString();
        },
      });
      return () => {
        removeExitIntent();
      };
    }
  });

  return (
    <Fragment>
      <Script
        strategy="idle"
        dangerouslySetInnerHTML={{
          __html: `(function(d){var s = d.createElement("script");s.setAttribute("data-account", "TmzYcdX1V8");s.setAttribute("src", "https://cdn.userway.org/widget.js");(d.body || d.head).appendChild(s);})(document)`,
        }}
      />
      <div className="relative max-w-[100vw] w-full h-full mx-auto">
        <PromoBar
          allPromos={data.allSanityPromobar.nodes}
          isOrderPage={isOrderPage}
        />
        <div
          className={`w-full mx-auto  ${
            data.allSanityPromobar.nodes.length > 0
              ? !isOrderPage
                ? "mt-[120px]"
                : "mt-0"
              : !isOrderPage
              ? "mt-[77px]"
              : "mt-0"
          }`}
        >
          {/* <Navbar /> */}
          {children}
          {!hidePopup &&
            data.sanityFooter.loyaltyButtonTitle &&
            data.sanityFooter.signupPopup.state && (
              <div className="bg-black text-white font-nunito font-medium px-5 py-2 fixed bottom-5 right-5 left-auto sm:left-auto flex items-center gap-2 z-10 flex-wrap w-fit">
                <button
                  aria-label="Close popup"
                  onClick={() => setHidePopup(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                    role="presentation"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18 18 6M6 6l12 12"
                    />
                  </svg>
                </button>{" "}
                <button onClick={() => setIsModalOpen(true)} className="">
                  {data.sanityFooter.loyaltyButtonTitle}
                </button>
              </div>
            )}
          <Popup
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            data={data.sanityFooter.signupPopup}
          />
          <Footer />
          <Toaster />{" "}
          {data.sanityFooter.enableExitIntent &&
            data.sanityFooter.exitPopup && (
              <ExitPopup
                data={data.sanityFooter.exitPopup}
                onClose={() => setExitPopup(false)}
                value={exitPopup}
              />
            )}
        </div>
        {/* <AccessibilityWidget /> */}
      </div>
    </Fragment>
  );
};

export default Layout;
